import { LegalLayout, Section } from "@/components/LegalLayout";
import { BUSINESS } from "@/lib/site";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Kebijakan Refund" subtitle="Ketentuan pengembalian dana untuk pembelian tiket di EventKu.">
      <Section title="1. Acara Dibatalkan oleh Penyelenggara">
        <p>Jika acara dibatalkan oleh Penyelenggara, pembeli berhak atas <span className="text-white font-semibold">refund 100%</span> dari harga tiket. Dana dikembalikan ke metode pembayaran asal dalam waktu <span className="text-white font-semibold">7–14 hari kerja</span> setelah pengumuman pembatalan.</p>
      </Section>
      <Section title="2. Acara Dijadwalkan Ulang (Reschedule)">
        <p>Jika acara dijadwalkan ulang, tiket Anda tetap berlaku untuk tanggal baru. Bila Anda tidak dapat hadir pada jadwal baru, Anda dapat mengajukan refund maksimal 7 hari setelah pengumuman reschedule.</p>
      </Section>
      <Section title="3. Pembatalan oleh Pembeli">
        <p>Tiket yang sudah dibeli pada dasarnya <span className="text-white font-semibold">tidak dapat direfund</span> (non-refundable) untuk pembatalan atas kehendak pembeli, kecuali dinyatakan lain oleh Penyelenggara pada acara tertentu.</p>
      </Section>
      <Section title="4. Tiket yang Sudah Digunakan">
        <p>Tiket yang QR Code-nya sudah dipindai/digunakan untuk masuk acara tidak memenuhi syarat untuk refund.</p>
      </Section>
      <Section title="5. Biaya Layanan">
        <p>Biaya layanan dan biaya transaksi payment gateway (jika ada) bersifat tidak dapat dikembalikan, kecuali untuk kasus pembatalan penuh oleh Penyelenggara.</p>
      </Section>
      <Section title="6. Cara Mengajukan Refund">
        <p>Kirim permintaan ke {BUSINESS.email} dengan menyertakan: nama pemesan, email pembelian, nama acara, dan kode/ID tiket. Tim kami akan memproses permintaan pada jam layanan {BUSINESS.hours}.</p>
      </Section>
      <Section title="7. Kontak">
        <p>{BUSINESS.name} — {BUSINESS.address}. Email: {BUSINESS.email} · Telp/WA: {BUSINESS.phone}.</p>
      </Section>
    </LegalLayout>
  );
}
